var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainPlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 27.5806V17.5806M6.5 17.5806L9.5875 16.9631C11.651 16.5519 13.7895 16.7481 15.7438 17.5281C17.8608 18.3744 20.1906 18.5322 22.4025 17.9793L22.67 17.9131C23.0498 17.8183 23.387 17.5992 23.628 17.2907C23.869 16.9822 23.9999 16.602 24 16.2106V7.00182C23.9999 6.77402 23.948 6.54924 23.8481 6.34452C23.7482 6.13981 23.6029 5.96053 23.4234 5.82029C23.2439 5.68006 23.0348 5.58255 22.812 5.53517C22.5892 5.48778 22.3585 5.49177 22.1375 5.54682C20.0982 6.05628 17.9503 5.91019 15.9987 5.12932L15.7438 5.02807C13.7899 4.24839 11.6519 4.05212 9.58875 4.46307L6.5 5.08057M6.5 17.5806V13.8306M6.5 5.08057V2.58057M6.5 5.08057V8.83057",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPlaces);
export default __webpack_public_path__ + "static/media/mainPlaces.e372917b2ae4414742833bcd2c11e818.svg";
export { ForwardRef as ReactComponent };